import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { InWinImage } from 'routes/shared/components'

// TODO: temp solution
export const PaymentMethodCell = ({ value }) =>
  value ? (
    <InWinImage source={value} alt={value} style={{ width: '48px' }} />
  ) : (
    <FontAwesomeIcon size="xl" icon={['far', 'credit-card']} />
  )

PaymentMethodCell.propTypes = {
  value: PropTypes.string,
}
